import Vue from 'vue';
import VueRouter from 'vue-router';
import { getToken } from "@/utils/auth";
Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/',
    // name: 'index',
    component: () => import('../views/index.vue'),
    children: [
      // 首页
      {
        path: '',
        name: 'home',
        component: () => import('../views/home')
      },
      {
        path: 'patient-detail',
        name: 'patientDetail',
        component: () => import('../views/patientDetail')
      },


    ]
  },

]




const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 路由拦截
router.beforeEach((to, from, next) => {
  // 所以一定要加to.path !== 'login'的判断
  if (to.path !== '/login') {
    if (getToken()) {
      next();
    } else {
      next('/login')
    }
  } else {
    next()
  }
});
export default router
